import { useNavigate } from 'react-router';
import {
  usePendingTasksStatus,
  useRefreshPendingTasks,
} from '@/hooks/react-query/usePendingTasks';
import { resolvePendingTaskTarget } from './pendingTaskNavigation';
import { PendingTasksTable } from './PendingTasksTable';
import type { PendingTask } from '@/types/pendingTasks';

export function PendingTasksCard() {
  const navigate = useNavigate();
  const { data: status } = usePendingTasksStatus();
  const refreshPendingTasks = useRefreshPendingTasks();

  const handleTaskClick = (task: PendingTask) => {
    const target = resolvePendingTaskTarget(task);
    if (!target) return;
    navigate(target.path);
  };

  // The table owns the paginated list query (and its loading/empty states);
  // the card supplies navigation, the last-updated time, and the refresh action.
  return (
    <PendingTasksTable
      onSelectTask={handleTaskClick}
      lastUpdated={status?.last_updated ?? null}
      onRefresh={() => refreshPendingTasks.mutate()}
      isRefreshing={refreshPendingTasks.isPending}
    />
  );
}
